import { TeamOutlined } from '@ant-design/icons';
import React from 'react';
import { FormValidatorBuilder } from '../../../../../validator';
import { getParentValidationScope } from '../../../../../validator/utils/getParentValidationScope';
import { tran } from '../../../../translations/schema/TranslationSchema';
import { IWidgetType } from '../../../IWidgetType';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget';
import { CompanyWidgetComponent } from './CompanyWidgetComponent';
import { CompanyWidgetConfigComponent } from './CompanyWidgetConfigComponent';
import { CompanyWidgetConfigSchema } from './CompanyWidgetConfigSchema';
import { ICompanyWidget } from './ICompanyWidget';

export const CompanyWidgetType: IWidgetType<ICompanyWidget> = {
  type: WidgetType.Company,
  mainType: WidgetMainType.Container,
  category: WidgetCategory.Advanced,
  name: 'Anagrafica Azienda',
  icon: <TeamOutlined />,
  formComponent: CompanyWidgetComponent,
  createFormSchema: ({ widget, parentScope, section, page }) => {
    const widgetScope = getParentValidationScope(widget, parentScope, {
      // Aggiungo a tutti i widget figli che sono discendenti da un widget di tipo Company
      // così da poter fare riferimento al parentCompany nell'estrazione dei rappresentanti legali
      extraMeta: { parentCompany: widget.id },
    });

    return FormValidatorBuilder.createWidgetsSchemaShape(
      widget.children,
      section,
      page,
      widgetScope,
    );
  },
  previewComponent: CompanyWidgetComponent,
  configValidator: CompanyWidgetConfigSchema,
  configComponent: CompanyWidgetConfigComponent,
  translationSchema: tran.widget({}),
  rules: [],
  hasValue: false,
  configOptions: {
    removeCollapsePanel: true,
  },
};
